import cn from 'classnames'
import { useSnapshot } from 'valtio'
import { type ReactElement, useCallback } from 'react'
import { proxyGlobalAuth } from '../../../../../shared/proxies/proxyGlobalAuth'
import { proxyNewUser, resetFormValues } from '../../../../../shared/proxies/newUserProxy'

export function MerchantUsersTableHeaderNoSort (): ReactElement {
  const { siteTheme: { tableHeaderColors, buttonColors } } = useSnapshot(proxyGlobalAuth)

  const onClick = useCallback(() => {
    resetFormValues()
    proxyNewUser.displayUserAddModal = true
  }, [])

  return (
    <th
      className={cn(tableHeaderColors.backgroundClasses, ' py-2 px-4 cursor-pointer')}
    >
      <div className="flex ">
        <button
          type="button"
          className={cn(buttonColors.invertedClasses, 'text-white px-4 py-2 rounded-md')}
          onClick={onClick}
        >
          Add user
        </button>
      </div>
    </th>
  )
}
